import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import api from '../../apis/EdisonApi';
import { toast } from "react-toastify";

const WasherDryer = () => {

    const [status, setStatus] = useState('NA');

    useEffect(() => {
        const controller = new AbortController();
        getStatus();

        return () => {
            controller.abort();
        };
    }, []);

    const getStatus = async () => {
        let config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: localStorage.getItem('idToken')
            },
        };

        try {
            const resp = await api.get('/bosch-stats', config);
            setStatus(resp.data.data);
        } catch(err) {
            toast.error('API error, please resfresh the page');
        }
    };

    const renderDoorStatus = () => {
        if (status !== 'NA') {
            return <div className="count">{ status.DoorState }</div>;            
        } else {             
            return <div className="count">NA</div>;
        }
    };

    const renderConnection = () => {
        if (status === 'NA') {
            return <div className="count">Disconnected</div>;
        } else {
            return <div className="count">Connected</div>;
        }
    };

    const renderLocalControl = () => {
        if (status !== 'NA') {            
            return <div className="count">{ status.LocalControlActive === true ? "True" : "False" }</div>;            
        } else {             
            return <div className="count">NA</div>;
        }
    };

    const renderOperationState = () => {
        if (status !== 'NA') {
                return <div className="count">{ status.OperationState }</div>;
        } else {             
            return <div className="count">NA</div>;
        }
    };

    const renderRemoteControl = () => {
        if (status !== 'NA') {            
            return <div className="count">{ status.RemoteControlActive === true ? "True" : "False" }</div>;
        } else {             
            return <div className="count">NA</div>;
        }
    };

    const renderRemoteStart = () => {
        if (status !== 'NA') {
            return <div className="count">{ status.RemoteControlStartAllowed === true ? "True" : "False" }</div>;
        } else {             
            return <div className="count">NA</div>;
        }
    };

    const renderDetails = () => {
                        
        if (status === 'NA')  {
            return (
                <div className="x_content">
                    <div>Device ID: washerdryer1</div>                                                                   
                    <div>Connection: Disconnected</div>            
                    <div>Door Status: NA</div>
                    <div>Local Control: NA</div>
                    <div>Operation State: NA</div>
                    <div>Remote Control Active: NA</div>
                    <div>Remote Start Allowed: NA</div>
                </div>
            );
        } else {
            return (
                <div className="x_content">
                    <div>Device ID: washerdryer1</div>                                                                   
                    <div>Connection: Connected</div> 
                    <div>Door Status: { status.DoorState }</div>
                    <div>Local Control: { status.LocalControlActive === true ? "True" : "False" }</div>
                    <div>Operation State: { status.OperationState }</div>
                    <div>Remote Control Active: { status.RemoteControlActive === true ? "True" : "False" }</div>
                    <div>Remote Start Allowed: { status.RemoteControlStartAllowed === true ? "True" : "False" }</div>
                </div>
            );
        }
    };
    
    return (
        <div className="right_col" role="main">
            <header className="page-heading device-page-heading">
                <div>
                    <p className="eyebrow">CONNECTED DEVICE</p>
                    <h1>Washer-dryer</h1>
                </div>
            </header>

            <div className="page-title">
                <div className="row top_tiles">
                    <div className="animated flipInY col-lg-4 col-md-4 col-sm-12 col-xs-12">
                        <div className="tile-stats">
                            <h3>Connection</h3> 

                            { renderConnection() }                           
                                
                        </div>
                    </div>
                    <div className="animated flipInY col-lg-4 col-md-4 col-sm-12 col-xs-12">
                        <div className="tile-stats">
                            <h3>Door Status</h3>
                            { renderDoorStatus() }
                        </div>
                    </div>
                    <div className="animated flipInY col-lg-4 col-md-4 col-sm-12 col-xs-12">
                        <div className="tile-stats">
                            <h3>Local Control</h3>
                            { renderLocalControl() }
                        </div>
                    </div> 
                    <div className="animated flipInY col-lg-4 col-md-4 col-sm-12 col-xs-12">
                        <div className="tile-stats">
                            <h3>Operation State</h3>
                            { renderOperationState() }
                        </div>
                    </div> 
                    <div className="animated flipInY col-lg-4 col-md-4 col-sm-12 col-xs-12">
                        <div className="tile-stats">
                            <h3>Remote Control Active</h3>
                            { renderRemoteControl() }
                        </div>
                    </div> 
                    <div className="animated flipInY col-lg-4 col-md-4 col-sm-12 col-xs-12">
                        <div className="tile-stats">
                            <h3>Remote Start Allowed</h3>
                            { renderRemoteStart() }
                        </div>
                    </div>           
                </div>
            </div>            

            <div className="row">
                <div className="col-xs-12">
                    <div className="x_panel">
                        <div className="x_title">
                            <h2>Details</h2>
                            <ul className="nav navbar-right panel_toolbox">
                                <li><span id="collapse-link-details" className="collapse-link"><FontAwesomeIcon icon={faChevronUp} size="lg" /></span>
                                </li>
                                <li><span className="close-link"><FontAwesomeIcon icon={faClose} size="lg" /></span>
                                </li>
                            </ul>
                            <div className="clearfix"></div>
                        </div>
                        
                        { renderDetails() }
                            
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WasherDryer;
